import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "logo logo-dark" }, null, -1)
const _hoisted_2 = {
  class: "box",
  "data-cy": "pending-verification"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "dots-top",
  src: "/kandidaten/img/dot-pattern-top.svg"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "dots-bottom",
  src: "/kandidaten/img/dot-pattern-bottom.svg"
}, null, -1)
const _hoisted_5 = { class: "box-content" }
const _hoisted_6 = { class: "headline" }
const _hoisted_7 = { class: "verify-text" }
const _hoisted_8 = { class: "newmail-input" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = { class: "success-message" }
const _hoisted_11 = { class: "verification-buttons" }

import { getCurrentInstance, ref } from "vue";
    import { createAuthenticationService } from '@/services/authenticationService';
    import { useToast } from 'primevue/usetoast';
    import { useI18n } from "vue-i18n";
    import useVuelidate from "@vuelidate/core";
    import { email, helpers, required } from "@vuelidate/validators";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeEmail',
  emits: ['email-verified', 'error'],
  setup(__props, { expose: __expose, emit: __emit }) {


    const emit = __emit;
    const toaster = useToast();
    const app = getCurrentInstance();
    const display = ref(false);
    const { t } = useI18n();
    const user = ref([]);


    const service = createAuthenticationService(app);

    const show = async () => {
        display.value = true;
    };

    const rules = {
        emailAddress: {
            required: helpers.withMessage(t("Eingabe wird benötigt"), required),
            email: {
                required: helpers.withMessage(
                    "Es wird eine valide E-Mail-Adresse benötigt.",
                    email
                ),
            },
        },
    };

    const v$ = useVuelidate(rules, user);

    const validate = () => {
        v$.value.$touch();
        if (v$.value.$invalid) {
            return v$.value.$error;
        }
    };
    const changeEmail = async () => {
        if (validate())
            return;
        let success = false
        try {
            success = await service.changeEmail(app, user.value.emailAddress);
        } catch {
            success = false;
        }
        if (success) {
            toaster.add({
                severity: "success",
                summary: t("change.mail.toast.success.title"),
                detail: t("change.mail.toast.success.text"),
                life: 5000,
            });
            emit('email-changed');
            display.value = false;
        } else {
            toaster.add({
                severity: "error",
                summary: t("change.mail.toast.error.title"),
                detail: t("change.mail.toast.error.text"),
                life: 5000,
            });
        }
        
    }


    __expose({
        show
    });

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: display.value,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((display).value = $event)),
    modal: true,
    class: "verification-dialog",
    baseZIndex: 106
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('change.email.headline')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('change.email.text')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_InputText, {
                  type: "text",
                  "data-cy": "new-email",
                  modelValue: _unref(v$).emailAddress.$model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).emailAddress.$model) = $event)),
                  class: _normalizeClass({ 'p-invalid': _unref(v$).emailAddress.$invalid })
                }, null, 8, ["modelValue", "class"]),
                _createElementVNode("label", null, _toDisplayString(_unref(t)("change.email.newmail")), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).emailAddress.$errors, (error, index) => {
                return (_openBlock(), _createElementBlock("small", {
                  class: "p-error",
                  key: index
                }, _toDisplayString(error.$message), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Button, {
                  label: _unref(t)('back'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (display.value = false)),
                  class: "button-secondary button-rectangle"
                }, null, 8, ["label"]),
                _createVNode(_component_Button, {
                  label: _unref(t)('change.email.button'),
                  onClick: changeEmail,
                  class: "button-primary button-rectangle"
                }, null, 8, ["label"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})